import { Button, Grid, TextField } from '@mui/material';
import SectionFormBox from '../../../../components/SectionFormBox/SectionFormBox';
import AutocompleteComponent from '../../../../components/layout/Autocomplete';
import { useTranslation } from 'react-i18next';
import Input from '../../../../components/Input/Input';

interface Props {
    formData: any;
    provinces: any[];
    cities: any[];
    contracts: any[];
    organisms: any[];
    filtersEstablecimientos: any;
    organizacionesOptions: any[];
    ciiuOptions: any[];
    isFetchingCiiuOptions?: boolean;
    isFetchingContracts: boolean;
    handleChange: (event: any) => void;
    handleFiltersEstablecimientosChange: (name: string, value: any) => void;
    handleContractSelection: (value: any) => void;
    cleanEstablecimientosFilters: (value: any) => void;
}

export default function CreateVisitasFilters({
    formData,
    provinces,
    cities,
    contracts,
    organisms,
    filtersEstablecimientos,
    organizacionesOptions,
    ciiuOptions,
    isFetchingCiiuOptions,
    isFetchingContracts,
    handleChange,
    handleFiltersEstablecimientosChange,
    handleContractSelection,
    cleanEstablecimientosFilters
}: Props) {
    const { t } = useTranslation('visitas');
    return (
        <SectionFormBox className="2" title={t('newVisit.establishmentInfo')}>
            <Grid item xs={12} sm={6} md={12/5}>
                <AutocompleteComponent
                    value={filtersEstablecimientos.idOrganizacion}
                    options={organizacionesOptions}
                    size="small"
                    name="idOrganizacion"
                    label="Cliente"
                    onChange={(value: any) =>
                        handleFiltersEstablecimientosChange('idOrganizacion', value)
                    }
                />
            </Grid>

            <Grid item xs={12} sm={6} md={12/5}>
                <AutocompleteComponent
                    value={formData.nroContrato || null}
                    options={contracts.map((contract) => ({
                        nombre: `${contract.nombre}`,
                        id: contract.id,
                        value: contract.nroContrato
                    }))}
                    disabled={isFetchingContracts}
                    loading={isFetchingContracts}
                    size="small"
                    name="nroContrato"
                    label={`${t('filters.contract')} *`}
                    onChange={(value: any) => handleContractSelection(value)}
                />
            </Grid>

            <Grid item xs={12} sm={6} md={12/5}>
                <AutocompleteComponent
                    value={formData.idOrganismo || null}
                    options={formData?.nroContrato ? organisms : []}
                    disabled={!formData?.nroContrato?.id}
                    size="small"
                    name="idOrganismo"
                    label={`${t('filters.organism')} *`}
                    onChange={(value: any) =>
                        handleChange({ target: { name: 'idOrganismo', value } })
                    }
                />
            </Grid>

            <Grid item xs={12} sm={6} md={12/5}>
                <Input
                    label={t('filters.establishment') as string}
                    size="small"
                    name="nombre"
                    onChange={(e) => handleFiltersEstablecimientosChange('nombre', e.target.value)}
                    value={filtersEstablecimientos?.nombre || ''}
                    clearable
                />
            </Grid>

            <Grid item xs={12} sm={6} md={12/5}>
                <Input
                    label={t('filters.srtCode') as string}
                    size="small"
                    name="codigoSRT"
                    onChange={(e) =>
                        handleFiltersEstablecimientosChange('codigoSRT', e.target.value)
                    }
                    value={filtersEstablecimientos?.codigoSRT || ''}
                    clearable
                />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
                <AutocompleteComponent
                    value={formData.provincia || null}
                    options={provinces}
                    size="small"
                    name="idProvincia"
                    label={t('filters.province')}
                    onChange={(value: any) =>
                        handleChange({ target: { name: 'idProvincia', value } })
                    }
                />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
                <AutocompleteComponent
                    value={formData.ciudad || null}
                    options={cities}
                    size="small"
                    name="ciudad"
                    label={t('filters.city')}
                    disabled={!formData.idProvincia}
                    onChange={(value: any) => handleChange({ target: { name: 'ciudad', value } })}
                />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
                <Input
                    label={t('filters.calle') as string}
                    size="small"
                    name="nombre"
                    onChange={(e) => handleFiltersEstablecimientosChange('calle', e.target.value)}
                    value={filtersEstablecimientos?.calle || ''}
                    clearable
                />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
                <AutocompleteComponent
                    value={filtersEstablecimientos?.idCiiu || null}
                    options={ciiuOptions}
                    loading={isFetchingCiiuOptions}
                    size="small"
                    name="idCiiu"
                    label={t('filters.ciiu') as string}
                    templateLabel={(option: any) =>
                        option?.codigo && option?.descripcion
                            ? `${option.codigo} - ${option.descripcion}`
                            : ''
                    }
                    onChange={(value: any) => handleFiltersEstablecimientosChange('idCiiu', value)}
                />
            </Grid>
            <Grid item xs={12} display="flex" justifyContent="flex-end" mt={2}>
                <Button variant="outlined" size="small" onClick={cleanEstablecimientosFilters}>
                    Limpiar filtros
                </Button>
            </Grid>
        </SectionFormBox>
    );
}
